/**
 * Vanilla port of views/windows/Scroll.svelte — same layout, scrollbar, and behavior.
 */

function mountLandingScroll(root) {
	const container = root;
	const content = root.querySelector(".content");
	const size = root.querySelector(".landing-scroll-size");
	const bar = root.querySelector(".bar");
	const knob = root.querySelector(".knob");

	if (!container || !content || !size || !bar || !knob) {
		return function noop() {};
	}

	let isDragging = false;
	let initialDragLocation;
	let initialContentOffset;

	function didScrollContent() {
		const scrollMax = content.scrollHeight - container.clientHeight;

		if (scrollMax <= 0) {
			knob.style.top = "0px";

			return;
		}

		const knobMax = bar.clientHeight - knob.clientHeight - 4.0;
		const top = Math.min(Math.max((content.scrollTop / scrollMax) * knobMax, 0.0), knobMax);

		knob.style.top = top + "px";
	}

	function resize() {
		const scrollHeight = Math.max(content.scrollHeight, 1);
		const knobHeight = Math.round((container.clientHeight / scrollHeight) * bar.clientHeight);

		knob.hidden = knobHeight > bar.clientHeight;
		knob.style.height = knobHeight + "px";

		didScrollContent();
	}

	function didMouseDown(e) {
		e.preventDefault();
		e.stopPropagation();

		isDragging = true;
		root.classList.add("dragging");
		initialDragLocation = e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;
		initialContentOffset = content.scrollTop;
	}

	function didMouseMove(e) {
		if (isDragging === false) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const y = e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;
		const offset = (y - initialDragLocation) * (bar.clientHeight / knob.clientHeight);

		content.scrollTop = initialContentOffset + offset;
	}

	function didMouseUp() {
		if (isDragging === true) {
			root.classList.remove("dragging");
		}

		isDragging = false;
	}

	function onScroll() {
		didScrollContent();
	}

	content.addEventListener("scroll", onScroll);
	knob.addEventListener("mousedown", didMouseDown);
	knob.addEventListener("touchstart", didMouseDown, { passive: false });

	document.addEventListener("mousemove", didMouseMove);
	document.addEventListener("mouseup", didMouseUp);
	document.addEventListener("touchmove", didMouseMove, { passive: false });
	document.addEventListener("touchend", didMouseUp);

	let observer;

	if (typeof ResizeObserver !== "undefined") {
		observer = new ResizeObserver(resize);

		observer.observe(container);
		observer.observe(size);
	}

	resize();

	return function destroyLandingScroll() {
		content.removeEventListener("scroll", onScroll);
		knob.removeEventListener("mousedown", didMouseDown);
		knob.removeEventListener("touchstart", didMouseDown);
		document.removeEventListener("mousemove", didMouseMove);
		document.removeEventListener("mouseup", didMouseUp);
		document.removeEventListener("touchmove", didMouseMove);
		document.removeEventListener("touchend", didMouseUp);

		if (observer !== undefined) {
			observer.unobserve(container);
			observer.unobserve(size);
		}
	};
}

export function initLandingScrolls() {
	const roots = document.querySelectorAll(".landing-window-body--scroll .scroll");

	for (let i = 0; i < roots.length; i++) {
		mountLandingScroll(roots[i]);
	}
}
